export enum ConsumeCostType {
  POSTPAID = 1, // 后付费账单支出（账单开销）
  PREPAID = 2, // 预付费服务支出
  FREEZE = 3, // 冻结
  DRAW = 4, // 提现
}

export interface IBillingAccountInfo {
  readonly account_balance: string; // 可用余额
  readonly account_freeze: string; // 冻结金额
  readonly account_debt: string; // 欠款金额
  readonly account_cash: string; // 现金金额
}

export interface IBillingConsumeCost {
  readonly consume_id: string; // 消费记录id
  readonly studio_id: string;
  readonly game_id: string; // 支付的游戏id
  readonly service_id: string; // 支付的服务id
  readonly type: ConsumeCostType; // 消费类型
  readonly amount: string; // 消费金额
  readonly create_time: string; // 消费日期
}

export interface ICostDetailsDetail {
  readonly consume_type: number; // 消费内容-返回的名称
  readonly amount: string; // 支出金额
}
export interface ICostOverviewDetails {
  readonly balance: string; // 账户月末余额
  readonly last_balance: string; // 账户上月末余额
  readonly detail: ReadonlyArray<ICostDetailsDetail>;
}

export interface ICostOverview {
  readonly date: string; // 日期
  readonly income: string; // 收入
  readonly expenses: string; // 支出
  readonly details: ICostOverviewDetails;
}
